<template>
  <div class="de">
    <Splash
      :splashImages="splashImages"
      :splashIntro="splashIntro"
      v-show="getIsSplashOpen"
      :pageTitle="pageTitle"
      :lang="'de'"
    />

    <!-- PAGE TITLE -->
    <div class="page-title" :class="mobileView === true ? 'mobile' : null">
      {{ pageTitle.de }}
    </div>

    <div class="image-grid-wrapper">
      <Card
        v-for="(collection, index) in collections"
        :key="index"
        :lang="'de'"
        :data="collection"
        :id="'#card-' + index"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Splash from "@/components/Splash.vue";
// @ is an alias to /src
import Card from "../components/Card.vue";

export default {
  name: "De",
  components: {
    Card,
    Splash,
  },
  props: {
    collections: {
      type: Object,
      default: null,
    },
    splashImages: {
      type: Array,
      default: null,
    },
    splashIntro: {
      type: Object,
      default: null,
    },
    pageTitle: {
      type: Object,
      default: null,
    },
    mobileView: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
      ...mapGetters(["getIsSplashOpen", "getLanguage"]),
  },
  methods: {
        ...mapActions(["languageAction"]),
  },
  mounted() {
      this.languageAction('de');
  }
};
</script>
